import React from "react";
import { GeneralInfoTab } from "../GeneralInfoTab";
import { GeneralInfoTabEditMode } from "../GeneralInfoTabEditMode";
import { GeneralInfoTabAutoPatrol } from "../GeneralInfoTabAutoPatrol";
import { SchedulesTab } from "../SchedulesTab";
import { SchedulesTabEditMode } from "../SchedulesTabEditMode";
import { SMTPTab } from "../SMTPTab";
import { RecordingServerTab } from "../RecordingServerTab";
import { RecordingServerTabEditMode } from "../RecordingServerTabEditMode";
import { CameraHealthTab } from "../CameraHealthTab";
import { CameraHealthTabEditMode } from "../CameraHealthTabEditMode";
import { Dispatcher } from "./siteAboutInterfaces";
import { WebhooksTab } from "../WebhooksTab";
import WebhooksTabEditMode from "../WebhooksTabEditMode";
import { EvalinkTab } from "../EvalinkTab";
import { EvalinkTabEditMode } from "../EvalinkTabEditMode";
import { WireGuardTab } from "../WireGuardTab";
import { WireGuardTabEditMode } from "../WireGuardTabEditMode";
import { WireGuardTunnel } from "./siteAboutInterfaces";
import { WireGuardEditSession } from "../WireGuardTabEditMode";
import { DOUBLE_TAKE_TAB } from "./siteDoubleTake";

export const handleClickedTabChange = (
  event: any,
  newValue: any,
  setClickedTab: any,
  editMode: any,
  setActiveTab: any,
  setPatchObject: any,
  setSiteInfo: any,
  vmsVariables: any,
  setVmsVariables: any,
  siteSchedules: any,
  siteInfo: any,
  setSiteSchedules: any,
  setSchedulesTabActive: any,
  setBackdropLoadingScreenOn: any,
  setAlertState: any,
  setSyncNeeded: any,
  setSiteInfoChangesMade: any,
  setScheduleChangesMade: any,
  setDeleteScheduleDialogOpen: any,
  recordingServerData: any,
  recordingServerPatchObject: any,
  setRecordingServerPatchObject: any,
  setRecordingServerChangesMade: any,
  healthCheckData: any,
  setCameraHealthPatchObject: any,
  setCameraHealthChangesMade: Dispatcher<boolean>,
  setAddCameraHealthDialogOpen: Dispatcher<boolean>,
  setTurnOffHealthDialogOpen: Dispatcher<boolean>,
  webhooksInfo: any,
  setWebhooksPatchObject: any,
  setWebhooksChangesMade: any,
  setEditMode: any,
  showWireguardTab: boolean,
  wireguardTunnels: WireGuardTunnel[],
  wireguardTunnelsLoading: boolean,
  selectedWireguardTunnelId: number | null,
  setSelectedWireguardTunnelId: React.Dispatch<
    React.SetStateAction<number | null>
  >,
  onWireGuardSessionUpdate: (session: WireGuardEditSession) => void,
  setWireguardChangesMade: Dispatcher<boolean>
) => {
  setClickedTab(newValue);

  const isAutoPatrol = siteInfo?.integration_type_name === "autopatrol";

  if (newValue === "one" && !editMode) {
    if (isAutoPatrol) {
      setActiveTab(<GeneralInfoTabAutoPatrol editMode={false} />);
    } else {
      setActiveTab(
        <GeneralInfoTab
          siteInfo={siteInfo}
          setSiteInfo={setSiteInfo}
          setActiveTab={setActiveTab}
          vmsVariables={vmsVariables}
        />
      );
    }
    setSchedulesTabActive(false);
  } else if (newValue === "one" && editMode) {
    if (isAutoPatrol) {
      setActiveTab(<GeneralInfoTabAutoPatrol editMode={true} />);
    } else {
      setActiveTab(
        <GeneralInfoTabEditMode
          setPatchObject={setPatchObject}
          setSiteInfo={setSiteInfo}
          siteInfo={siteInfo}
          setSiteInfoChangesMade={setSiteInfoChangesMade}
          vmsVariables={vmsVariables}
          setVmsVariables={setVmsVariables}
        />
      );
    }
    setSchedulesTabActive(false);
  } else if (newValue === "three" && !editMode) {
    setActiveTab(<SchedulesTab siteInfo={siteInfo} />);
    setSchedulesTabActive(true);
  } else if (newValue === "three" && editMode) {
    setActiveTab(
      <SchedulesTabEditMode
        siteInfo={siteInfo}
        setEditMode={setEditMode}
        setSiteInfo={setSiteInfo}
        setActiveTab={setActiveTab}
      />
    );
    setSchedulesTabActive(true);
  } else if (newValue === "four") {
    setActiveTab(<SMTPTab />);
    setSchedulesTabActive(false);
  } else if (newValue === "five" && !editMode) {
    setActiveTab(
      <RecordingServerTab recordingServerData={recordingServerData} />
    );
    setSchedulesTabActive(false);
  } else if (newValue === "five" && editMode) {
    setActiveTab(
      <RecordingServerTabEditMode
        recordingServerData={recordingServerData}
        recordingServerPatchObject={recordingServerPatchObject}
        setRecordingServerPatchObject={setRecordingServerPatchObject}
        setRecordingServerChangesMade={setRecordingServerChangesMade}
      />
    );
    setSchedulesTabActive(false);
  } else if (newValue === "six" && !editMode) {
    setActiveTab(
      <CameraHealthTab healthCheckData={healthCheckData} siteInfo={siteInfo} />
    );
    setSchedulesTabActive(false);
  } else if (newValue === "six" && editMode) {
    setActiveTab(
      <CameraHealthTabEditMode
        healthCheckData={healthCheckData}
        setCameraHealthPatchObject={setCameraHealthPatchObject}
        setCameraHealthChangesMade={setCameraHealthChangesMade}
        siteInfo={siteInfo}
        setAddCameraHealthDialogOpen={setAddCameraHealthDialogOpen}
        setTurnOffHealthDialogOpen={setTurnOffHealthDialogOpen}
      />
    );
    setSchedulesTabActive(false);
  } else if (newValue === "seven" && !editMode) {
    setActiveTab(<WebhooksTab webhooksInfo={webhooksInfo} />);
    setSchedulesTabActive(false);
  } else if (newValue === "seven" && editMode) {
    setActiveTab(
      <WebhooksTabEditMode
        webhooksInfo={webhooksInfo}
        setWebhooksPatchObject={setWebhooksPatchObject}
        setWebhooksChangesMade={setWebhooksChangesMade}
      />
    );
    setSchedulesTabActive(false);
  } else if (newValue === DOUBLE_TAKE_TAB) {
    // SiteAbout renders the DoubleTake tab itself, with its own Save, like
    // WireGuard; only the schedule-only header buttons need clearing here.
    setSchedulesTabActive(false);
  } else if (newValue === "eight" && !editMode) {
    setActiveTab(<EvalinkTab />);
    setSchedulesTabActive(false);
  } else if (newValue === "eight" && editMode) {
    setActiveTab(<EvalinkTabEditMode />);
    setSchedulesTabActive(false);
  } else if (newValue === "nine" && showWireguardTab && !editMode) {
    setActiveTab(
      <WireGuardTab
        wireguardTunnels={wireguardTunnels}
        wireguardTunnelsLoading={wireguardTunnelsLoading}
        selectedTunnelId={selectedWireguardTunnelId}
        onSelectTunnelId={(id) => setSelectedWireguardTunnelId(id)}
      />
    );
    setSchedulesTabActive(false);
  } else if (newValue === "nine" && showWireguardTab && editMode) {
       setActiveTab(
      <WireGuardTabEditMode
        wireguardTunnels={wireguardTunnels}
        selectedTunnelId={selectedWireguardTunnelId}
        onSelectTunnelId={(id) => setSelectedWireguardTunnelId(id)}
        onSessionUpdate={onWireGuardSessionUpdate}
        setWireguardChangesMade={setWireguardChangesMade}
      />
    );
    setSchedulesTabActive(false);
  }
};
